<template lang="pug">
  div.image
    div.placeholder(v-if="loading", :style="'padding-top:' + ratio + ';'")
    img(v-else, :src="url")
</template>

<script>
import { storage } from '@/api/firebase'

export default {
  props: {
    path: {
      type: String
    },
    ratio: {
      default: '100%'
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      url: 'static/images/transparent-square.png'
    }
  },
  mounted () {
    this.loadFile()
  },
  methods: {
    loadFile () {
      if (this.path) {
        const storageRef = storage.ref()
        storageRef.child(this.path).getDownloadURL()
          .then((url) => {
            this.url = url
            this.loading = false
          })
          .catch((e) => {
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  position: relative;
  .placeholder {
  }
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FStorageImage.vue